var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-icon-pie-chart-fill'),_vm._v("  "+_vm._s(_vm.segment.name))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }